
<app-go-to-project></app-go-to-project>
<div class="constraction-tracking-holder" *ngIf="constructionPoint?.length > 0;" data-simplebar>
    <span class="constraction-note">המועדים המצוינים אינם מחייבים את החברה</span>
    <div class="constraction-tracking">
        <!-- <ul @slideRight *ngFor="let item of constructionPoint | sortgrid: '-date'" class="point-holder {{ item.color }}"  [class.no-active]='editState'> -->
        <ul @slideRight *ngFor="let item of constructionPoint | sortgrid: '-date'" class="point-holder {{ item.color }}"
            [class.no-active]='editState'>
            <li class="text" (click)='editItem($event, item)'>
                <div>
                    <h5>{{ item.title }}</h5>{{ item.text }}
                </div>
            </li>
            <li class="gal" (click)='editItem($event, item)'>
                <a href="javascript:;"></a>
            </li>
            <li class="ring" (click)='editItem($event, item)'>
                <span>
                    <div>{{ item.date | date:'dd'}}.{{item.date | date:'MM'}}.{{item.date | date:'yy'}}</div>
                </span>
            </li>

        </ul>
        <div *ngFor="let item of constructionPoint | sortgrid: '-date'">
                <div *ngIf="editState && itemToEdit.id == item.id" class="carusel-holder square-design">
                        <h5 class="title">{{ item.title }}</h5>
                        <p>{{ item.text }}</p>
                        <app-gallery [galleryId]="'1'" [section]="item.id+'video'" [autoPlay]="true" [showThumbs]="true" class="scroll white-background"></app-gallery>
                        <a class="close-section" href="javascript:;" (click)='closeItem()'></a>
                        <div class="upload-images" [class.active]="editState">
                        </div>
                </div>
        </div>
    </div>
    <div class="center-line-holder">
        <div class="centr-line"></div>
    </div>
</div>